import * as React from 'react';
import getDisplayName from 'recompose/getDisplayName';

import { Config } from 'ha/config';

import { ConfigConsumer } from './context';

export interface ConfigProps {
  appConfig: Config;
}

export function withConfig<P extends ConfigProps>(
  Component: React.ComponentType<P>,
) {
  const WithConfig: React.SFC<Omit<P, keyof ConfigProps>> = props => (
    <ConfigConsumer>
      {value => <Component {...(props as P)} appConfig={value} />}
    </ConfigConsumer>
  );

  WithConfig.displayName = `withConfig(${getDisplayName(Component)})`;

  return WithConfig;
}
